import { MAIN_SITE_URL } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxury%20boutique%20sneaker%20display%20on%20polished%20marble%20pedestal%20with%20dramatic%20spotlighting%20against%20dark%20charcoal%20backdrop%2C%20premium%20leather%20textures%20visible%2C%20exclusive%20high%20fashion%20retail%20window%20styling%2C%20sophisticated%20dark%20luxury%20aesthetic%20with%20golden%20accent%20lighting%2C%20editorial%20fashion%20photography&width=1600&height=900&seq=hero-2026-v3&orientation=landscape"
        alt="CSSBuy Spreadsheet fashion and sneaker finds curated agent shopping collection"
        title="CSSBuy Spreadsheet Agent Shopping Fashion Collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white text-xs md:text-sm font-medium mb-4 md:mb-6 tracking-wide">
            2026 Updated
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4 md:mb-6">
            Best CSSBuy Spreadsheet &amp; Agent Shopping Hub
          </h1>

          <p className="text-white/80 text-sm md:text-base max-w-lg mb-6 md:mb-8 leading-relaxed">
            Explore curated spreadsheets for CSSBuy, Kakobuy, Superbuy, and Oopbuy &mdash; updated daily with fashion, sneakers, and trending finds.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-5 h-5 flex items-center justify-center bg-black/20 rounded-full">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 bg-white/15 backdrop-blur-sm text-white border border-white/30 px-6 py-3 rounded-full text-sm font-semibold hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Spreadsheets
              <i className="ri-arrow-down-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}